'use client';

import { FC } from 'react';
import {
  CatTextLink,
  CatIconChevronRight,
  CatIconCube
} from 'components/blocks-components';
import { JobRecommendationDetail } from 'services/product/types';
import styles from './job-recommendations.module.scss';
import cx from 'classnames';
import { formatJobName } from '../../utils/repairListItem';

export interface RepairListItemProps {
  item: JobRecommendationDetail;
  onHandleClick: (ssId: string, isPM: boolean) => void;
  isButtonView?: boolean;
  isPCCFrequentlyBoughtTogether?: boolean;
}

const RepairListItem: FC<RepairListItemProps> = ({
  item,
  onHandleClick,
  isButtonView = false,
  isPCCFrequentlyBoughtTogether = false
}) => {
  const displayCapitalizeName = isPCCFrequentlyBoughtTogether
    ? formatJobName(item?.jobName)
    : item?.jobName;

  return isButtonView ? (
    <button
      onClick={() => onHandleClick(item.jobId, item.isPM)}
      className={cx(
        'w-100 d-flex justify-content-between align-items-center p-3',
        styles['job-button']
      )}
      data-testid="repair-mobile-button"
    >
      <div className="d-flex align-items-center text-start">
        <CatIconCube size="lg" />
        <span className="cat-u-theme-typography-label ms-3 ">
          {item?.jobName && `${displayCapitalizeName}`}
        </span>
      </div>
      <CatIconChevronRight className="ms-3" />
    </button>
  ) : (
    <div key={item.jobId}>
      <CatTextLink onClick={() => onHandleClick(item.jobId, item.isPM)}>
        {item.jobName}
      </CatTextLink>
    </div>
  );
};

export default RepairListItem;
